module.exports = __webpack_public_path__ + "be461e14195f97ac121b964253c9059d.png";